import type { MascotConfig } from './mascot-catalog'
import type { MascotGamePayload } from './game/mascot-game-types'

export function isSheepAvailable(catalog?: MascotGamePayload['catalog']): boolean {
  return (
    catalog?.mascot_available === true &&
    catalog.mascot_species?.includes('sheep') === true
  )
}

// Available immediately on entry; the API also covers other campaigns of this institution.
export function campaignMascotBackdrop(
  campaignId: number,
  requiredBackdrop?: MascotConfig['backdrop'] | null
): MascotConfig['backdrop'] | undefined {
  return campaignId === 65 ? 'farm' : (requiredBackdrop ?? undefined)
}

export function withMascotBackdrop(
  config: MascotConfig,
  requiredBackdrop?: MascotConfig['backdrop']
): MascotConfig {
  return requiredBackdrop ? { ...config, backdrop: requiredBackdrop } : config
}
